import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TODO: Replace with your Firebase config from Firebase Console
// Instructions:
// 1. Go to https://console.firebase.google.com
// 2. Create a new project (or use existing)
// 3. Go to Project Settings > General
// 4. Scroll to "Your apps" > Web app
// 5. Copy the firebaseConfig object and paste it below

const firebaseConfig = {

  apiKey: "AIzaSyD2iOelAUjQ1QP0F6HG2-LO4GW001Q_exY",

  authDomain: "allthese-d9ee1.firebaseapp.com",

  projectId: "allthese-d9ee1",

  storageBucket: "allthese-d9ee1.firebasestorage.app",

  messagingSenderId: "424377534203",

  appId: "1:424377534203:web:44f8009d60d80b5131925e",

  measurementId: "G-VGMJJ7BCJE"

};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
